export class EventAction {
    constructor(
        public id: number,
        public name: string,
        public message: string,
        public date: Date,
        public type: EventActionType,
        public isAllDayLong: boolean = true
    ) {}
}

export enum EventActionType {
    Deadline = 0,
    Reminder = 1,
}
